<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner" :style="{alignItems: 'flex-start'}">
      <div class="edit-popup edit-popup--add-flight">
        <div class="edit-popup__header edit-popup__header-flight">
          <div class="edit-popup__title">
            <span>Status: Cancel</span>
          </div>
          <div class="edit-popup__close">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

        <form>

<!--          РЕШЕНО ОТЛОЖИТЬ ЭТО МОДАЛЬНОЕ ОКНО 24 07 2022-->


<!--          <label-->
<!--              class="form-control-radio"-->
<!--              >-->
<!--            <input-->
<!--                type="radio"-->
<!--                name="activity_radio"-->
<!--                :checked="true" /><span-->
<!--              class="form-control-radio__box"></span-->
<!--          ><span class="form-control-radio__name"-->
<!--          >Before the Activity</span-->
<!--          >-->
<!--          </label>-->
        </form>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AtModalInvoiceStatusCancel'
}
</script>